import { map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataService, ApiService, InspectionPluginService } from '../../shared/services/index';
import { ApiMode } from '../../utils/enums';
import { OfflineApiService } from '../../shared/services/offlineApi.service';
import { AppConstants } from '../../utils/appConstants.class';
import { MachineSelectorFactoryService } from './machineselector-plugin-factory.service';

@Injectable()
export class MachineSelectorPluginService extends InspectionPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    offlineApi: OfflineApiService,
    private machineFactory: MachineSelectorFactoryService
  ) {
    super(apiService, dataService, offlineApi, machineFactory);
  }

  public checkPartsBook(inspectionId: string, pluginId: string): Observable<any> {
    return this.apiService.post(`/inspections/${inspectionId}/plugins/${pluginId}/partsbook/check`).pipe(
      map((inspectedObjects: any) => {
        this.dataService.updateInspectedData(inspectionId, inspectedObjects);
        return this.dataService.updatePluginConfig(inspectionId, pluginId, {
          ...inspectedObjects.machine,
          ModelId: inspectedObjects.machine.name
        });
      })
    );
  }

  public updateMachine(inspectionId: string, pluginId: string, machine: any): Observable<any> {
    return this._updateMachine(inspectionId, pluginId, machine).pipe(
      map((inspectedObjects: any) => {
        this.dataService.updateInspectedData(inspectionId, inspectedObjects);
        return this.dataService.updatePluginConfig(inspectionId, pluginId, {
          ...inspectedObjects.machine,
          ModelId: inspectedObjects.machine.name
        });
      })
    );
  }

  public getModels(): Observable<any> {
    const url = '/plugins/machineselector/models';
    return this.offlineApi.getWithMode(url, ApiMode.Offline, AppConstants.INDEXEDDB_TABLES.models);
  }

  public updateCategories(inspectionId: string, data: any) {
    const url = '/models/' + inspectionId + '/categories';
    return this.apiService.post(url, data).pipe(
      map((categories: any) => {
        this.dataService.updateCategories(inspectionId, categories);
      })
    ) as any;
  }

  private _updateMachine(inspectionId: string, pluginId: string, machine: any): Observable<any> {
    return this.machineFactory.updateMachine(inspectionId, pluginId, machine).pipe(
      flatMap((res) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(res.data);
        }
        return this.apiService.post(res.plugin.postServerUrl, res.plugin.config);
      })
    );
  }
}
